<template>
	<div class="sky-tabs-custom" :class="[className, customClass && 'custom-class']">
		<el-tabs v-model="activeName" v-bind="$attrs" @tab-click="handleClick">
			<el-tab-pane
				:disabled="disabled || item.disabled"
				v-for="(item, index) in tabListFitter"
				:key="index + item.label"
				:label="item[props.label]"
				:name="item[props.value]"
				v-bind="item"
			>
				<component
					v-if="item.type"
					:is="item.type"
					v-bind="{ ...item.attributes, ...$attrs }"
					v-on="$listeners"
				></component>
				<slot name="main"></slot>
			</el-tab-pane>
		</el-tabs>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'sky-tabs-custom',
	model: {
		prop: 'value',
		event: 'change',
	},
	props: {
		value: {
			required: true,
		},
		tabList: {
			required: true,
			type: Array,
		},
		customClass: {
			default: true,
		},
		className: {
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		props: {
			default() {
				return {
					label: 'label',
					value: 'name',
				};
			},
		},
	},
	data() {
		return {
			activeName: '',
		};
	},
	computed: {
		tabListFitter(self) {
			let { tabList } = self;
			return tabList.filter(tab => {
				let { isShow } = tab;
				if (isShow === undefined || isShow === true) return true;
				return false;
			});
		},
	},
	watch: {
		value: {
			handler(val) {
				this.activeName = val;
			},
		},
	},
	methods: {
		handleClick(tab, event) {
			this.$emit('change', tab.name);
			this.$emit('changeTab', tab, event);
		},
	},
	mounted() {
		this.activeName = this.value;
	},
};
</script>

<style lang="scss" scoped>
.sky-tabs-custom {
	// border:1px  red solid;
	width: 100%;
	// padding: 0 25px;
	display: flex;
	align-items: center;

	.el-tabs {
		width: 100%;
	}
}
</style>

<style>
.custom-class .el-tabs__nav-wrap::after {
	display: none;
}

.custom-class .el-tabs__item {
	font-size: 16px;
	font-weight: bold;
}

.custom-class .el-tabs__header {
	margin: 0 !important;
}
</style>
